// Vertical heat gauge: a 0..100 track with the golden band highlighted and the
// burn zone marked in red. The fill rises with current heat and turns gold
// while in-band. Pure presentation — it reads sim numbers, never writes them.

import Phaser from 'phaser';

const COLD_FILL = 0x4a90d9;
const BAND_FILL = 0xffb347;
const HOT_FILL = 0xff5a3c;
const TRACK = 0x241809;
const TRACK_BORDER = 0x3a2a12;
const BAND_OVERLAY = 0xffb347;
const BURN_OVERLAY = 0xff3b2f;

export class HeatGauge {
  private g: Phaser.GameObjects.Graphics;

  constructor(
    scene: Phaser.Scene,
    private x: number,
    private y: number,
    private w: number,
    private h: number,
  ) {
    this.g = scene.add.graphics();
    this.g.setScrollFactor(0);
  }

  setLayout(x: number, y: number, w: number, h: number): void {
    this.x = x;
    this.y = y;
    this.w = w;
    this.h = h;
  }

  private yFor(heat: number): number {
    const clamped = heat < 0 ? 0 : heat > 100 ? 100 : heat;
    return this.y + this.h * (1 - clamped / 100);
  }

  update(heat: number, bandMin: number, bandMax: number, burnThreshold: number): void {
    const g = this.g;
    g.clear();

    // Track.
    g.fillStyle(TRACK, 1);
    g.fillRect(this.x, this.y, this.w, this.h);

    // Burn zone (threshold..100).
    const burnTop = this.yFor(100);
    const burnBottom = this.yFor(burnThreshold);
    g.fillStyle(BURN_OVERLAY, 0.28);
    g.fillRect(this.x, burnTop, this.w, burnBottom - burnTop);

    // Golden band.
    const bandTop = this.yFor(bandMax);
    const bandBottom = this.yFor(bandMin);
    g.fillStyle(BAND_OVERLAY, 0.32);
    g.fillRect(this.x, bandTop, this.w, bandBottom - bandTop);

    // Current heat fill.
    const inBand = heat >= bandMin && heat <= bandMax;
    const fill = heat > burnThreshold ? HOT_FILL : inBand ? BAND_FILL : COLD_FILL;
    const fillTop = this.yFor(heat);
    g.fillStyle(fill, 0.95);
    g.fillRect(this.x, fillTop, this.w, this.y + this.h - fillTop);

    // Border + band edge lines.
    g.lineStyle(2, TRACK_BORDER, 1);
    g.strokeRect(this.x, this.y, this.w, this.h);
    g.lineStyle(1, BAND_OVERLAY, 0.9);
    g.lineBetween(this.x, bandTop, this.x + this.w, bandTop);
    g.lineBetween(this.x, bandBottom, this.x + this.w, bandBottom);
  }

  destroy(): void {
    this.g.destroy();
  }
}
